/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EntityChangeType = 0 | 1 | 2;

export const EntityChangeType = {
    NUMBER_0: 0 as EntityChangeType,
    NUMBER_1: 1 as EntityChangeType,
    NUMBER_2: 2 as EntityChangeType
};

